"use client"

import { usePathname, useSearchParams } from "next/navigation"
import { useEffect, useRef } from "react"
import NProgress from "nprogress"
import "nprogress/nprogress.css"

export default function ProgressProvider({
  children,
}: {
  children: React.ReactNode
}) {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    NProgress.configure({ showSpinner: false, trickleSpeed: 100 })
  }, [])

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      const link = (e.target as HTMLElement).closest("a")
      if (!link) return
      if (link.closest("[data-progress-ignore='true']")) return
      if (link.target === "_blank" || link.hasAttribute("download")) return
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return
      if (!link.href || link.origin !== window.location.origin) return

      const nextUrl = new URL(link.href)
      const current = window.location

      if (
        nextUrl.pathname === current.pathname &&
        nextUrl.search === current.search
      ) {
        return
      }

      NProgress.start()

      // Clear any existing timeout
      if (timeoutRef.current) clearTimeout(timeoutRef.current)

      // Force complete after 10 seconds
      timeoutRef.current = setTimeout(() => {
        NProgress.done()
      }, 10000)
    }

    document.addEventListener("click", handleClick)
    return () => document.removeEventListener("click", handleClick)
  }, [])

  useEffect(() => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current)
    NProgress.done()
  }, [pathname, searchParams])

  return <>{children}</>
}
